import styled from 'styled-components';
import factoryButton from './utils/factoryButton';
import BaseBtnSC from './styles/BaseBtnSC';
const ButtonIconSC = styled(BaseBtnSC) `
  min-width: ${(props) => props.theme.SizeWidthButtonIconBase};
  min-height: ${(props) => props.theme.SizeHeightButtonIconBase};
  width: ${(props) => props.theme.SizeWidthButtonIconBase};
  max-width: ${(props) => props.theme.SizeWidthButtonIconBase};
  height: ${(props) => props.theme.SizeHeightButtonIconBase};
  max-height: ${(props) => props.theme.SizeHeightButtonIconBase};

  padding: 0;
  border-radius: 50%;

  &._ndsBtn--large {
    min-width: ${(props) => props.theme.SizeWidthButtonIconLarge};
    min-height: ${(props) => props.theme.SizeHeightButtonIconLarge};
    width: ${(props) => props.theme.SizeWidthButtonIconLarge};
    max-width: ${(props) => props.theme.SizeWidthButtonIconLarge};
    height: ${(props) => props.theme.SizeHeightButtonIconLarge};
    max-height: ${(props) => props.theme.SizeHeightButtonIconLarge};
    padding: 0;
    border-radius: 50%;
  }

  ::before {
    height: calc(100% + 0.125rem);
    border-radius: 50%;
    min-height: calc(100% + 0.125rem);
  }

  &._ndsBtn--large::before {
    border-radius: 50%;
    min-height: calc(100% + 0.125rem);
  }

  &._ndsBtn--loading:disabled {
    background-color: ${(props) => props.theme.ColorBackgroundButtonIconLoading};
  }

  &._ndsBtn--grey._ndsBtn--loading:disabled {
    background-color: ${(props) => props.theme.ColorBackgroundButtonIconGreyLoading};
  }

  &._ndsBtn--destructive._ndsBtn--loading:disabled {
    background-color: ${(props) => props.theme.ColorBackgroundButtonIconErrorLoading};
  }

  & > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonIconBase};
  }

  &._ndsBtn--grey > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonIconGrey};
  }

  &._ndsBtn--destructive > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonIconError};
  }

  :hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonIconHover};
  }

  &._ndsBtn--grey:hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonIconGreyHover};
  }

  &._ndsBtn--destructive:hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonIconErrorHover};
  }

  :disabled > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonIconDisabled};
  }

  &._ndsBtn--grey:disabled,
  &._ndsBtn--destructive:disabled,
  :disabled {
    background-color: transparent;
  }

  &._ndsBtn--loading .icon {
    height: ${(props) => props.theme.SizeHeightIconButtonIconBase};
    margin-right: 0;
  }

  &._ndsBtn--loading._ndsBtn--large .icon {
    height: ${(props) => props.theme.SizeHeightIconButtonIconLarge};
    margin-right: 0;
  }
`;
export default factoryButton(ButtonIconSC, 'icon-only');
//# sourceMappingURL=ButtonIcon.js.map